import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  article: undefined,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_MACHINE_ARTICLE:
      return {
        ...state,
        isLoading: true,
        error: false,
        article: undefined,
      };

    case types.RECEIVE_MACHINE_ARTICLE_RESPONSE:
      return {
        ...state,
        isLoading: false,
        error: false,
        article: action.payload,
      };

    case types.RECEIVE_MACHINE_ARTICLE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
        article: undefined,
      };
    default:
      return state;
  }
}
